export default __webpack_public_path__ + "static/media/discover.5affae38.svg";